import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { LOCALES } from "../utils/localisationConfig";

import enTranslation from "./en-us/translation.json";
import esTranslation from "./es-us/translation.json";

const resources = {
  [LOCALES.EN_US]: {
    translation: enTranslation,
  },
  [LOCALES.ES_US]: {
    translation: esTranslation,
  },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: [LOCALES.EN_US],
  lowerCaseLng: true,
  debug: ["dev"].includes(process.env.GATSBY_ENV),
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
